export default [
  {
    CommissionData: "01",
    SubCategory: "Rugs",
    Vendor: "All",
    Type: "Fixed",
    Fee: "20",
    Createdon: "8/7/2021"
  },
  {
    CommissionData: "02",
    SubCategory: "Watches",
    Vendor: "RR Enterprises",
    Type: "Percentage",
    Fee: "5",
    Createdon: "8/7/2021"
  },
  {
    CommissionData: "03",
    SubCategory: "Table",
    Vendor: "All",
    Type: "Percentage",
    Fee: "10",
    Createdon: "8/7/2021"
  },
  {
    CommissionData: "04",
    SubCategory: "Table",
    Vendor: "Active",
    Type: "Furnitures",
    Fee: "900",
    Createdon: "8/7/2021"
  }
];
